import { styled } from "styled-components"
import theme from "../../styles/theme";

const MainWrap = styled.div`
    width: 100%;
    height: 40px;
    padding: 0px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${theme.color.black[10]};;

    h3 {
        display: inline-block;
        font-size: 1.2rem;
        line-height: 1.8rem;
        padding: 0;
        margin: 0;
        margin-top: 0.3rem;
    }

    img {
        display: inline-block;
        cursor: pointer;
    }
`;

const CommonModalBar = ({title, close}) => {

    return (
        <MainWrap>
            <h3>{title}</h3>
            <img src={`/images/ic_close.svg`} onClick={close}/>
        </MainWrap>
    )
}

export default CommonModalBar;